const timestamp_to_date_with_time_heb = (timestamp) => {
    // Convert nanoseconds and seconds to milliseconds
    const milliseconds = timestamp.seconds * 1000 + timestamp.nanoseconds / 1e6;

    // Create a Date object
    const date = new Date(milliseconds);

    // Get hours, minutes, day, month, and year
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Month is zero-based
    const year = date.getFullYear();

    // Format the string
    return `${day}/${month}/${year} ,${hours}:${minutes}`;
}

// get date string in this format: '2023-07-12';
// return as a result this format: '12/07/2023'


// diff dates string in this format 'yyyy-mm--dd', return the days diff between them
function calculateDateDifference(start_date, end_date) {
    const startDate = new Date(start_date);
    const endDate = new Date(end_date);
  
  
    // Calculate the difference in milliseconds between the two dates
    const timeDifference = endDate.getTime() - startDate.getTime();
  
    // Check for negative difference
    if (timeDifference < 0) {
      throw new Error("תאריך ההתחלה גבוה מתאריך הסיום!");
    }
    if (timeDifference == 0) {
      throw new Error("עליך לבחור תאריכים שונים!");
    }
  
    // Convert milliseconds to days
    const daysDifference = timeDifference / (1000 * 3600 * 24);
  
    // Round the result to get an integer number of days
    return Math.round(daysDifference);
}

function israeli_format_Date_string(dateString) {
    const dateParts = dateString.split('-'); // Split the date string into year, month, and day parts
    const year = dateParts[0];
    const month = dateParts[1];
    const day = dateParts[2];
  
    // Create a Date object using the year, month, and day
    const date = new Date(year, month - 1, day);
  
    // Extract the day, month, and year from the Date object and format them
    const formattedDay = ('0' + date.getDate()).slice(-2);
    const formattedMonth = ('0' + (date.getMonth() + 1)).slice(-2);
    const formattedYear = date.getFullYear();
  
    // Return the formatted date string in 'dd/mm/yyyy' format
    return `${formattedDay}/${formattedMonth}/${formattedYear}`;
}


// return ISO date with UTC Z 
const get_date_now = ()=>{
    const date = new Date().toISOString()
    return date
}

// return the format and local date of the user 
const display_date_from_iso = (iso_date) => {
    const local_zone = Intl.DateTimeFormat().resolvedOptions().timeZone
    const user_lang = navigator.languages && navigator.languages.length
    ? navigator.languages[navigator.languages.length-1]
    : navigator.language
    return new Date(iso_date).toLocaleDateString(user_lang, {timeZone:local_zone})
}

// return the format and local date and time of the user 
const display_date_and_time_from_iso = (iso_date) => {
    const local_zone = Intl.DateTimeFormat().resolvedOptions().timeZone
    const user_lang = navigator.languages && navigator.languages.length
    ? navigator.languages[navigator.languages.length-1]
    : navigator.language

    return new Date(iso_date).toLocaleString(user_lang, {timeZone:local_zone})
}

// return the format and local time of the user 
const display_only_time_from_iso = (iso_date) => {
    const local_zone = Intl.DateTimeFormat().resolvedOptions().timeZone
    const user_lang = navigator.languages && navigator.languages.length
    ? navigator.languages[navigator.languages.length-1]
    : navigator.language

    return new Date(iso_date).toLocaleTimeString(user_lang, {timeZone:local_zone})
}

// return date object with no time - Good for comparing
const get_object_date_with_no_time = (dateString)=>{
    const d=new Date(dateString)
    d.setHours(0,0,0,0)
    return d
}
// return date object with no time - Good for comparing
const get_object_date_with_time = (dateString)=>{
    const d=new Date(dateString)
    return d
}

// return date object with time when the data is timstamp from server 
const timestamp_to_date_with_time=(date)=>{
    let d
    if(date._second) d = new Date(date._seconds * 1000)
    if(date.second) d = new Date(date.seconds * 1000)
    return d
}

// return date object with no time when the data is timstamp from server 
const timestamp_to_date_no_time=(date)=>{
    let d
    if(date._seconds) d = new Date(date._seconds * 1000)
    if(date.seconds) d = new Date(date.seconds * 1000)
    d.setHours(0,0,0,0)
    return d
}

// Time difference between 2 Dates:
const time_diff_calc = (dateFuture, dateNow) => {
    let diffInMilliSeconds = Math.abs(dateFuture - dateNow) / 1000;

    // calculate days
    const days = Math.floor(diffInMilliSeconds / 86400);
    diffInMilliSeconds -= days * 86400;

    // calculate hours
    const hours = Math.floor(diffInMilliSeconds / 3600) % 24;
    diffInMilliSeconds -= hours * 3600;

    // calculate minutes
    const minutes = Math.floor(diffInMilliSeconds / 60) % 60;
    diffInMilliSeconds -= minutes * 60;

    let difference = '';
    if (days > 0) {
      difference += (days === 1) ? `${days} day, ` : `${days} days, `;
    }

    difference += (hours === 0 || hours === 1) ? `${hours} hour, ` : `${hours} hours, `;

    difference += (minutes === 0 || hours === 1) ? `${minutes} minutes` : `${minutes} minutes`; 

    return [days, hours, minutes];
}

/* ------------------------------------------------------------------ */
/*  Israeli date / time formatting - independent of the browser locale  */
/* ------------------------------------------------------------------ */

// Every computer must show the same thing, so we never let the browser pick
// the pattern (toLocaleDateString('he') silently falls back to US format when
// the Hebrew locale data is missing) and never let it pick the zone (that
// follows the Windows clock, which is sometimes set wrong).
const IL_TIME_ZONE = 'Asia/Jerusalem'

// matches the 'yyyy-mm-dd' value that <input type="date"> always holds
const ISO_DAY_RE = /^(\d{4})-(\d{2})-(\d{2})$/
// matches the 'HH:mm' / 'HH:mm:ss' value that <input type="time"> always holds
const ISO_TIME_RE = /^(\d{1,2}):(\d{2})(:(\d{2}))?$/

// accepts a Date, a firestore Timestamp, a plain {seconds,nanoseconds} (what a
// Timestamp turns into after JSON.stringify/parse), millis or a date string
const to_date = (value) => {
    if (value === null || value === undefined || value === '') return null
    if (value instanceof Date) return isNaN(value.getTime()) ? null : value
    if (typeof value.toDate === 'function') return to_date(value.toDate())
    if (typeof value === 'object') {
        const seconds = value.seconds !== undefined ? value.seconds : value._seconds
        const nanos = value.nanoseconds !== undefined ? value.nanoseconds : value._nanoseconds
        if (seconds === undefined) return null
        return to_date(seconds * 1000 + (nanos ? nanos / 1e6 : 0))
    }
    const d = new Date(value)
    return isNaN(d.getTime()) ? null : d
}

// 'en-US' is the one locale present in every browser build, and we rebuild the
// string from the parts ourselves, so the locale pattern never reaches the screen
const il_parts = (date) => {
    try {
        const parts = new Intl.DateTimeFormat('en-US', {
            timeZone: IL_TIME_ZONE,
            year: 'numeric', month: '2-digit', day: '2-digit',
            hour: '2-digit', minute: '2-digit', second: '2-digit',
            hourCycle: 'h23'
        }).formatToParts(date)
            .reduce((acc, part) => { acc[part.type] = part.value; return acc }, {})
        // some older Chromium builds print midnight as '24' under hourCycle h23
        if (parts.hour === '24') parts.hour = '00'
        return parts
    } catch (err) {
        // last resort if Intl is unavailable - falls back to the device zone
        const pad = (n) => n.toString().padStart(2, '0')
        return {
            day: pad(date.getDate()), month: pad(date.getMonth() + 1), year: `${date.getFullYear()}`,
            hour: pad(date.getHours()), minute: pad(date.getMinutes()), second: pad(date.getSeconds())
        }
    }
}

// always 'dd/mm/yyyy' - e.g. '10/09/2026'
const format_date_il = (value) => {
    // a plain calendar date is reordered as text: sending it through a time zone
    // is what causes off-by-one-day bugs
    if (typeof value === 'string') {
        const iso = value.match(ISO_DAY_RE)
        if (iso) return `${iso[3]}/${iso[2]}/${iso[1]}`
    }
    const date = to_date(value)
    if (!date) return ''
    const p = il_parts(date)
    return `${p.day}/${p.month}/${p.year}`
}

// always 24 hour 'HH:mm' - e.g. '18:45' (pass true for 'HH:mm:ss')
const format_time_il = (value, with_seconds = false) => {
    // the value of <input type="time"> is already 24 hour, whatever the browser draws
    if (typeof value === 'string') {
        const iso = value.match(ISO_TIME_RE)
        if (iso) {
            const hh = iso[1].padStart(2, '0')
            return with_seconds ? `${hh}:${iso[2]}:${iso[4] || '00'}` : `${hh}:${iso[2]}`
        }
    }
    const date = to_date(value)
    if (!date) return ''
    const p = il_parts(date)
    return with_seconds ? `${p.hour}:${p.minute}:${p.second}` : `${p.hour}:${p.minute}`
}

// 'dd/mm/yyyy HH:mm' - e.g. '10/09/2026 18:45'
const format_date_time_il = (value, with_seconds = false) => {
    const date = to_date(value)
    if (!date) return ''
    const p = il_parts(date)
    const time = with_seconds ? `${p.hour}:${p.minute}:${p.second}` : `${p.hour}:${p.minute}`
    return `${p.day}/${p.month}/${p.year} ${time}`
}

// the Israeli calendar day as 'yyyy-mm-dd' - sorts and compares as plain text,
// so date-range filters agree with what format_date_il puts on the screen
const il_day_key = (value) => {
    if (typeof value === 'string') {
        const iso = value.match(ISO_DAY_RE)
        if (iso) return value
    }
    const date = to_date(value)
    if (!date) return ''
    const p = il_parts(date)
    return `${p.year}-${p.month}-${p.day}`
}

export{
    israeli_format_Date_string,
    get_date_now,
    display_date_from_iso,
    display_date_and_time_from_iso,
    display_only_time_from_iso,
    get_object_date_with_no_time,
    get_object_date_with_time,
    timestamp_to_date_with_time,
    timestamp_to_date_no_time,
    time_diff_calc,
    calculateDateDifference,
    timestamp_to_date_with_time_heb,
    format_date_il,
    format_time_il,
    format_date_time_il,
    il_day_key
}
